export default {
  state: {
    parkCode: '',
    parkId: '',
    ycToken: '',
    userInfo: {},
    token: '',
    entryQuery: '',
    ycUserInfo: {},
    tokenInfo: {}, // ioc底座token信息
    tokenStartTime: 0, // 保存ioc底座token的时间
  },
  getters: {
    entryQuery: state => state.entryQuery || '', // 子服务入口页面参数
    sourceApp: state => state.entryQuery?.sourceApp || '', // 小程序/app来源标识
    entryTitle: state => state.entryQuery?.title || '', // 子服务标题
    appKey: state => state.entryQuery?.appId || '', // 子服务标识
    parkCode: state => state.parkCode || '', // 当前园区编码
    parkId: state => state.parkId || '', // 当前园区id
    token: state => state.token, // ioc底座token
    tokenInfo: state => state.tokenInfo, // ioc底座token
    tokenStartTime: state => state.tokenStartTime, // 保存ioc底座token的时间
    ycToken: state => state.ycToken || '', // 云城token
    ycUserInfo: state => state.ycUserInfo, // 云城用户信息
    uuid: state => state.userInfo.thirdUserId, // 用户uuid
    userInfo: state => state.userInfo, // 用户信息
    userId: state => state.userInfo?.id, // 用户id
    nickname: state => state.userInfo.name ||state.userInfo.userName, // 用户昵称
    mobilePhone: state => state.userInfo.phone || state.userInfo.account, // 手机号
    realName: state => state.userInfo.realName, // 用户真实姓名
  },
  mutations: {
    // 保存当前园区id
    setParkId: (state, data) => {
      state.parkId = data || '';
    },
    // 保存当前园区编码
    setParkCode: (state, data) => {
      console.log('bianma',data)
      state.parkCode = data || '';
    },
    // 保存云城token
    setYcToken: (state, data) => {
      state.ycToken = data;
    },
    // 保存云城用户信息
    setYcUserInfo: (state, data) => {
      state.ycUserInfo = data;
    },
    // 保存子服务入口页面的参数
    saveEntryQuery: (state, data) => {
      state.entryQuery = data;
    },
    // 保存用户信息
    setUserInfo: (state, data = {}) => {
      const userInfo = { ...data };
      if (data.userId || data.user_id) {
        userInfo.id = data.userId || data.user_id;
      }
      state.userInfo = userInfo;
    },
    // 保存底座token
    setToken(state, data) {
      state.token = data;
    },
    // 保存底座接口返回的全部token数据
    setTokenInfo(state, data) {
      state.tokenInfo = data;
    },
    setTokenStartTime(state, data) {
      state.tokenStartTime = data;
    },
    setMobile(state, data) {
      state.mobilePhone = data;
    },
    setRealName(state, data) {
      state.userInfo.realName = data;
    },
  },
  actions: {},
};
